<div class="min-vh-100 bg-light">
  <app-header [page]="'Support'"></app-header>

  <main class="container py-4">
    <div class="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
      <div>
        <h4 class="mb-0 fw-bold">Help Center</h4>
        <div class="text-muted small">
          Browse frequently asked questions and support guidance
        </div>
      </div>
        <div class="d-flex gap-2">
            <button class="btn btn-outline-secondary btn-sm" type="button" (click)="loadFaqs()">
                Refresh
            </button>
            <button class="btn btn-outline-primary btn-sm" *ngIf="isLoggedIn$ | async" routerLink="/support/tickets" type="button">
                Open Support Ticket
            </button>
        </div>
    </div>

    <div class="card shadow-sm border-0 mb-3">
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-8">
            <label class="form-label">Search</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="query"
              (input)="applyFilters()"
              placeholder="Search payments, deposits, rates, orders, accounts, KYC..."
            />
          </div>

          <div class="col-md-4">
            <label class="form-label">Category</label>
            <select
              class="form-select"
              [(ngModel)]="selectedCategory"
              (change)="applyFilters()">
              <option *ngFor="let item of categories" [value]="item">
                {{ item }}
              </option>
            </select>
          </div>

          <div class="col-12">
            <button class="btn btn-outline-secondary btn-sm" type="button" (click)="clearFilters()">
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card shadow-sm border-0">
      <div class="card-body">
        <div *ngIf="loading" class="text-center py-4">
          <div class="spinner-border spinner-border-sm me-2"></div>
          Loading help articles...
        </div>

        <div *ngIf="!loading && !filteredFaqs.length" class="text-center text-muted py-4">
          No FAQ items found.
        </div>

        <div class="accordion" id="helpCenterAccordion" *ngIf="!loading && filteredFaqs.length">
          <div class="accordion-item" *ngFor="let item of filteredFaqs; let i = index">
            <h2 class="accordion-header">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                [attr.data-bs-target]="'#faq-' + i">
                <div>
                  <div class="fw-semibold">{{ item.question }}</div>
                  <div class="small text-muted">{{ item.category }}</div>
                </div>
              </button>
            </h2>

            <div
              [id]="'faq-' + i"
              class="accordion-collapse collapse"
              data-bs-parent="#helpCenterAccordion">
              <div class="accordion-body">
                {{ item.answer }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
  </main>
</div>